<div class="confirmation-dialog-container">
    <div class="confirmation-dialog-header align-items-center">
        <div class="dialog-title-styles">{{data.title}}</div>
        <div class="d-flex align-items-center close-dialog-btn" (click)="closeDialog(false)" style="line-height:1;">
            <mat-icon class="cursor-pointer" style="font-size: 18px; width: 18px; height: 18px;">close</mat-icon>
        </div>
    </div>
    <div class="confirmation-dialog-body">
        <mat-dialog-content class="mat-typography" [innerHTML]="data.message">
        </mat-dialog-content>
    </div>
    <div class="confirmation-dialog-footer">
        <button class="btn confirm-button" (click)="closeDialog(true)"
                [style.background-color]="(data.ok === 'Delete' || data.ok === 'DELETE' || data.ok === 'delete') ? '#dc2626' : null">
            {{data.ok || 'Ok'}}
        </button>
        <button *ngIf="!data.isCancelDisabled" class="btn cancel-button" (click)="closeDialog(false)">
            {{data.cancel || 'Cancel'}}
        </button>
    </div>
</div>